<template>
  <v-card>
    <v-card-text class="text-center">
      <div>在庫管理アプリをご利用の方は、Googleアカウントでログインしてください。</div>
    </v-card-text>
    <v-card-actions class="justify-center">
      <v-btn @click="loading">Googleアカウントでログイン</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    loading() {
      this.login();
      this.$router.push({ name: "loading" });
    },
    ...mapActions(["login"]),
  },
};
</script>

<style></style>
